import React from 'react';
import _ from 'lodash';
import { toFixed } from 'humanize-plus';

import styles from './sellsideConsensusStyles';

import HoverOverTooltip from 'buyside/components/presentation/Tooltips/HoverOverTooltip/hoverOverTooltip';

const SellsideConsensus = ({ sellsideConsensus }) => {
  return (
    <HoverOverTooltip
      overlay={[
        <div key="1" className={_.inRange(sellsideConsensus, 0.01, 1.24) ? styles.highlighted : ''}>
          0.0 - 1.24 <span className={styles.tooltipRight}>Buy</span>
        </div>,
        <div key="2" className={_.inRange(sellsideConsensus, 1.25, 1.74) ? styles.highlighted : ''}>
          1.25 - 1.74 <span className={styles.tooltipRight}>Overweight</span>
        </div>,
        <div key="3" className={_.inRange(sellsideConsensus, 1.75, 2.24) ? styles.highlighted : ''}>
          1.75 - 2.24 <span className={styles.tooltipRight}>Hold</span>
        </div>,
        <div key="4" className={_.inRange(sellsideConsensus, 2.25, 2.74) ? styles.highlighted : ''}>
          2.25 - 2.74 <span className={styles.tooltipRight}>Underweight</span>
        </div>,
        <div key="5" className={_.inRange(sellsideConsensus, 2.75, 3.0) ? styles.highlighted : ''}>
          2.75 - 3.0 <span className={styles.tooltipRight}>Sell</span>
        </div>
      ]}
    >
      {sellsideConsensus ? toFixed(sellsideConsensus, 2) : <span className={styles.na}>N/A</span>}
    </HoverOverTooltip>
  );
};

export default SellsideConsensus;
